{
  "confirmDialog": {
    "no": "Нет",
    "yes": "Да",
    "logoutTitle": "Вы действительно хотите выйти из аккаунта?",
    "watchListTitle": "Вы уверены, что хотите удалить данный тикер?",
    "confirmDeleteAll": "Вы уверены, что хотите удалить все виджеты?",
    "cancel": "Отмена",
    "confirmDeleteTemplate": "Вы уверены, что хотите удалить шаблон?",
    "confirmApplyTemplate": "У вас уже имеются виджеты, хотите их заменить?",
    "delete": "Удалить",
    "apply": "Применить",
    "confirm": "Подтвердить"
  }
}
